/** @format */

import { GTMListingCard } from '@/@ducks/googleTagManager/helpers/google-tag-manager';
import { selectorAvailabilityRoom } from '@/ducks/shared/selectors';
import { useAppTranslation } from '@/i18n/declarations';
import React, { useCallback } from 'react';
import { selectorFilters } from '../../../@ducks/listing/selectors';
import { TRoom } from '../../../@ducks/room/declarations';
import { useAppSelector } from '../../../redux/hooks';
import { utilityGTMListingSelectItem } from '../../../utils/helpers/utilityGTMListingSelectItem';
import Availability from './Availability';
import { useCardRoomContext } from './context';
import Details from './Details';
import Gallery from './Gallery';
import { BottomDetails, Card, CardInfo, CardLink, Divider, Title } from './index.style';
import Price from './Price';

export const CardRoom: React.FC<CardRoomProps> = ({ isLoadingAvailability, availableFrom, index }) => {
  const { intl } = useAppTranslation();
  const { url, title, room } = useCardRoomContext();
  const { code } = room || {};
  const roomAvailability = useAppSelector(store => selectorAvailabilityRoom(store, code ?? ''));

  const filters = useAppSelector(selectorFilters);

  const handleClickCardInfo = useCallback(() => {
    if (code) {
      GTMListingCard(code, 'property_type');
    }
  }, [code]);

  const gtmSelectItem = useCallback(() => {
    utilityGTMListingSelectItem(room as TRoom, roomAvailability, intl, index ?? 1, filters);
  }, [code]);

  return (
    <Card>
      <Gallery gtmSelectItem={gtmSelectItem} />
      <CardLink to={url} target="_blank" rel="noopener noreferrer nofollow" onClick={gtmSelectItem}>
        <CardInfo onClick={handleClickCardInfo}>
          <Title>{title}</Title>
          <Details />
          <Divider />
          <BottomDetails>
            {!isLoadingAvailability && <Price />}
            <Availability bedCode={code} isLoading={isLoadingAvailability} availableFrom={availableFrom} />
          </BottomDetails>
        </CardInfo>
      </CardLink>
    </Card>
  );
};

interface CardRoomProps {
  hasInactiveURL?: boolean;
  isLoadingAvailability: boolean;
  availableFrom: string | undefined;
  index?: number;
}
